import request from '@/utils/request'

// 推荐关键词列表
export function recommendKeywordList(data) {
    return request({
        url: '/recommend-keyword-list/list',
        method: 'post',
        data
    })
}
// 新增推荐关键词
export function createRecommendKeyWord(data) {
  return request({
      url: '/recommend-keyword-list/create',
      method: 'post',
      data
  })
}
// 修改推荐关键词
export function upDateRecommendKeyWord(data) {
  return request({
      url: '/recommend-keyword-list/update',
      method: 'post',
      data
  })
}

// 删除推荐关键词
export function deleteRecommendKeyWord(data) {
  return request({
      url: '/recommend-keyword-list/delete',
      method: 'post',
      data
  })
}

// 词库管理-新增关键词
export function addKeyword(data) {
  return request({
      url: '/recommend-keyword/create',
      method: 'post',
      data
  })
}

// 词库管理-查询关键词
export function keywordList(data) {
  return request({
      url: '/recommend-keyword/list',
      method: 'post',
      data
  })
}
// 词库管理-修改关键词状态
export function updateKeywordStatus(data) {
  return request({
      url: '/recommend-keyword/update-state',
      method: 'post',
      data
  })
}
// 词库管理-删除关键词
export function deleteKeyword(data) {
  return request({
      url: '/recommend-keyword/delete',
      method: 'post',
      data
  })
}
// 反爬设置（频次设置）-列表
export function frequencyConfigList(data) {
  return request({
      url: '/frequency-config/list',
      method: 'post',
      data
  })
}
// 反爬设置（频次设置）-新增
export function frequencyConfigCreate(data) {
  return request({
      url: '/frequency-config/create',
      method: 'post',
      data
  })
}
// 反爬设置（频次设置）-编辑
export function frequencyConfigUpdate(data) {
  return request({
      url: '/frequency-config/update',
      method: 'post',
      data
  })
}
// 反爬设置（频次设置）-删除
export function frequencyConfigDelete(data) {
  return request({
      url: '/frequency-config/delete',
      method: 'post',
      data
  })
}
// 白名单ip-列表
export function ipAddressWhiteList(data) {
  return request({
    url: '/ip-address-whitelist/list',
    method: 'post',
    data,
  })
}
// 白名单ip-新增
export function ipAddressWhiteCreate(data) {
  return request({
    url: '/ip-address-whitelist/create',
    method: 'post',
    data,
  })
}
// 白名单ip-编辑
export function ipAddressWhiteUpdate(data) {
  return request({
    url: '/ip-address-whitelist/update',
    method: 'post',
    data,
  })
}
// 白名单ip -删除
export function ipAddressWhiteDelete(data) {
  return request({
    url: '/ip-address-whitelist/delete',
    method: 'post',
    data,
  })
}

// 公共信息管理-列表
export function contactList(data) {
  return request({
    url: '/contact/list',
    method: 'post',
    data,
  })
}
// 公共信息管理-新增
export function contactCreate(data) {
  return request({
    url: '/contact/create',
    method: 'post',
    data,
  })
}
// 公共信息管理-编辑
export function contactUpdate(data) {
  return request({
    url: '/contact/update',
    method: 'post',
    data,
  })
}
// 公共信息管理 -删除
export function contactDelete(data) {
  return request({
    url: '/contact/delete',
    method: 'post',
    data,
  })
}
// 公共信息管理类型-列表
export function contactTypeListData(data) {
  return request({
    url: '/contact-type/list',
    method: 'post',
    data,
  })
}
// 公共信息管理类型-新增
export function contactTypeCreate(data) {
  return request({
    url: '/contact-type/create',
    method: 'post',
    data,
  })
}
// 公共信息管理类型-编辑
export function contactTypeUpdate(data) {
  return request({
    url: '/contact-type/update',
    method: 'post',
    data,
  })
}

export default {
  recommendKeywordList,
  createRecommendKeyWord,
  upDateRecommendKeyWord,
  deleteRecommendKeyWord,
  keywordList,
  addKeyword,
  updateKeywordStatus,
  deleteKeyword,
  frequencyConfigList,
  frequencyConfigCreate,
  frequencyConfigUpdate,
  frequencyConfigDelete,
  ipAddressWhiteList,
  ipAddressWhiteCreate,
  ipAddressWhiteUpdate,
  ipAddressWhiteDelete,
  contactList,
  contactCreate,
  contactUpdate,
  contactDelete,
  contactTypeListData,
  contactTypeCreate,
  contactTypeUpdate,
}
